import {
  FETCH_CATEGORY_DETAILS_REQUEST,
  FETCH_CATEGORY_DETAILS_SUCCESS,
  FETCH_CATEGORY_DETAILS_FAILURE,
  RESET_CATEGORY_STATE,
} from '../../../types/category';

const initialState = {
  loading: false,
  category: null,
  error: null,
  success: false,
};

const fetchCategoryDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATEGORY_DETAILS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: null,
        success: false,
      });

    case FETCH_CATEGORY_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        category: action.payload,
        success: true,
      });

    case FETCH_CATEGORY_DETAILS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload,
        success: false,
      });

    case RESET_CATEGORY_STATE:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default fetchCategoryDetailsReducer;
